import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Integration Levels
                                    </h2>
                                    <p>
                                        You can choose to build out a basic-level integration or a more advanced-level integration, depending on the user
                                        experience you want to provide to your customers and the amount of resources you want to devote to building the
                                        integration. See Capabilities Available for a full list of available capabilities and their related API endpoints.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        UUID Mapping
                                    </h3>
                                    <p>
                                        Connect customers websites using a tracking pixel that map Audiencerate cookie to the user. Track all your Properties
                                        with a single line of code. Just copy/paste. Our cookie is keep alive for <b>15 days.</b>
                                        <br />
                                        <br />
                                        <pre style={{ 'background-color': 'transparent', color: 'black' }}>
                                            <div className="alert alert-secondary" role="alert">
                                                <code style={{ 'background-color': 'transparent', color: 'black' }}>
                                                    &lt;img src="https://a.audrte.com/get?r=https://ad.yoururl.com/pixel?user_id=$UID" height=1 width=1&gt;
                                                </code>
                                            </div>
                                        </pre>
                                    </p>

                                    
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        AR Hosted Matchtable Mapping
                                    </h3>
                                    <p>
                                        You can use AR hosted matchtable to track UUIDs using the matchtable mapping pixel.
                                        Please note that you need to contact Audiencerate support at <a href="mailto:admin@audiencerate.com">admin@audiencerate.com</a> to activate this endpoint.
                                        <br />
                                        <br />
                                        <pre style={{ 'background-color': 'transparent', color: 'black' }}>
                                            <div className="alert alert-secondary" role="alert">
                                                <code style={{ 'background-color': 'transparent', color: 'black' }}>
                                                    &lt;img src="https://a.audrte.com/match?uid=&lt;YOUR_UUID&gt;&amp;p=&lt;YOUR_PARTNERID&gt;" height=1 width=1&gt;
                                                </code>
                                            </div>
                                        </pre>
                                    </p>


                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Segment Upload
                                    </h3>
                                    <p>
                                        You can upload <b>mobile</b> ids or <b>adform</b> ids.
                                        <br />
                                        For more information about file upload please see <a href="/doc/file_upload">here</a>
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
